import { render } from "./inAppNotificationsModal.vue?vue&type=template&id=ca68c3c0&ts=true"
import script from "./inAppNotificationsModal.vue?vue&type=script&lang=ts"
export * from "./inAppNotificationsModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__